<div class="width-1200">

    <mat-card class='mat-card-top'>

        <mat-toolbar>

            <div class='title'>
                <mat-icon>mobile_off</mat-icon>
                <div style='font-size: 17px;'>
                    Reembolsos
                </div>

            </div>

            <div *ngIf="ngFlag">
                <button mat-button style='width:60px;' (click)="exportSolicitacoesToCsv()">
                    <mat-icon class='icon-close'>arrow_downward</mat-icon>
                </button>
            </div>
        </mat-toolbar>
    </mat-card>


    <mat-card class='header-select'>

        <mat-select (ngModelChange)='selectOrdersByProduct($event)' [ngModel]='selectedProduct.id'
            placeholder="Selecione um produto">
            <mat-option *ngFor="let product of arrayProducts" [value]="product.id">
                {{ product.name }}
            </mat-option>
        </mat-select>

        <div class='placar'>

            <div style='display: flex;'>
                <div style='display:inline-block; width: 100px;' *ngIf="ngFlag">
                    {{ countOrderedRefundRequest }} solicitados:
                </div>
                <div style='display:inline-block; width: 80px;  text-align: right;' *ngIf="ngFlag">
                    {{ totalOrderedRefundRequest | currency:'BRL':'':'1.2-2' }}
                </div>
            </div>

            <div style='display: flex; margin-left:50px;'>
                <div style='display:inline-block; width: 80px;' *ngIf="ngFlag">
                    {{ countOrderedRefund }} pagos:
                </div>
                <div style='display:inline-block; width: 80px; text-align: right;' *ngIf="ngFlag">
                    {{ totalOrderedRefund | currency:'BRL':'':'1.2-2' }}
                </div>
            </div>

        </div>

    </mat-card>


    <mat-card class='mat-card-body'>

        <mat-tab-group>

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class='tab-icon'>star_outline</mat-icon>
                    <div>Solicitar</div>
                </ng-template>

                <!-- TABLE -->
                <mat-table [dataSource]="orderedDataSource" matSort>

                    <!-- Icon Column -->
                    <ng-container matColumnDef="icon">
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <mat-icon style='font-size:1.2em; margin-top:10px;'>mobile_off</mat-icon>
                        </mat-cell>
                    </ng-container>

                    <!-- name Column -->
                    <ng-container matColumnDef="member_name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{ element.member_name }} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="total">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Valor </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <div>
                                {{ element.total | currency:'BRL':'':'1.2-2' }}
                            </div>
                        </mat-cell>
                    </ng-container>

                    <!-- edit Column -->
                    <ng-container matColumnDef="edit">
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <a mat-button (click)='RequestRefund(element)'
                                style='background-color: whitesmoke;'>
                                <mat-icon class='icon-info' style='font-size:1.5em;'>
                                    request_quote
                                </mat-icon>
                            </a>
                        </mat-cell>
                    </ng-container>

                    <!-- Header -->
                    <mat-header-row *matHeaderRowDef="displayedOrderColumns"></mat-header-row>

                    <!-- Row -->
                    <mat-row *matRowDef="let row; columns: displayedOrderColumns;"></mat-row>

                </mat-table>
                <!-- END TABLE -->

                <mat-paginator #paginator [pageSizeOptions]="[5, 10, 20, 40]"></mat-paginator>


            </mat-tab>


            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class='tab-icon'>star_half</mat-icon>
                    <div>Solicitado</div>
                </ng-template>

                <!-- TABLE -->
                <mat-table [dataSource]="orderedDataSourceRefundRequest" matSort>

                    <!-- Icon Column -->
                    <ng-container matColumnDef="icon">
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <mat-icon style='font-size:1.2em; margin-top:10px;'>mobile_off</mat-icon>
                        </mat-cell>
                    </ng-container>

                    <!--DAta Solicitação -->
                    <ng-container matColumnDef="dateRequest">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Dt Solicitação </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <span *ngIf='element.refund.dateRequest'>
                                {{ element.refund.dateRequest.seconds*1000 | date: 'dd/MM/yyyy' }}
                            </span>
                        </mat-cell>
                    </ng-container>

                    <!--Data pagamento -->
                    <ng-container matColumnDef="dateRefund">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Dt Pagamento </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <span *ngIf='element.refund.dateRefund'>
                                {{ element.refund.dateRefund.seconds*1000 | date: 'dd/MM/yyyy' }}
                            </span>
                        </mat-cell>
                    </ng-container>

                    <!-- name Column -->
                    <ng-container matColumnDef="member_name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{ element.member_name }} </mat-cell>
                    </ng-container>

                    x
                    <!-- Tid Column -->
                    <ng-container matColumnDef="tid">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> TID </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <div>
                                {{ element.Tid }}
                                <br>
                                {{ element.origin }}
                            </div>
                        </mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="bank">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Bc/Ag/Cc </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <div>
                                {{ element.refund.bank }}
                                <br>
                                {{ element.refund.agency }}
                                <br>
                                {{ element.refund.account }}
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="total">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Valor </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <div>
                                {{ element.total | currency:'BRL':'':'1.2-2' }}
                                <br>
                                {{ element.refund.discount }} %
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="refund">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Reembolso </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{ element.refund.total | currency:'BRL':'':'1.2-2' }}
                        </mat-cell>
                    </ng-container>

                    <!-- edit Column -->
                    <ng-container matColumnDef="edit">
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <a mat-button (click)='openRefundDialog(element, false)'
                                style='background-color: whitesmoke;'>
                                <mat-icon class='icon-info' style='font-size:1.5em;'>
                                    info_outline
                                </mat-icon>
                            </a>
                        </mat-cell>
                    </ng-container>

                    <!-- Header -->
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

                    <!-- Row -->
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

                    <!-- Footer 
                    <mat-row mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></mat-row>
-->
                </mat-table>
                <!-- END TABLE -->

                <mat-paginator #paginatorRefundRequest [pageSizeOptions]="[5, 10, 20, 40]"></mat-paginator>


            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class='tab-icon'>star</mat-icon>
                    <div>Pago</div>
                </ng-template>

                <!-- TABLE -->
                <mat-table [dataSource]="orderedDataSourceRefund" matSort>

                    <!-- Icon Column -->
                    <ng-container matColumnDef="icon">
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <mat-icon style='font-size:1.2em; margin-top:10px;'>list</mat-icon>
                        </mat-cell>
                    </ng-container>

                    <!--Data Solicitação -->
                    <ng-container matColumnDef="dateRequest">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Dt Solicitação </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <span *ngIf='element.refund && element.refund.dateRequest'>
                                {{ element.refund.dateRequest.seconds*1000 | date: 'dd/MM/yyyy' }}
                            </span>
                        </mat-cell>
                    </ng-container>

                    <!--Data pagamento -->
                    <ng-container matColumnDef="dateRefund">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Dt Pagamento </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <span *ngIf='element.refund && element.refund.dateRefund'>
                                {{ element.refund.dateRefund.seconds*1000 | date: 'dd/MM/yyyy' }}
                            </span>
                        </mat-cell>
                    </ng-container>

                    <!-- name Column -->
                    <ng-container matColumnDef="member_name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{ element.member_name }} </mat-cell>
                    </ng-container>


                    <!-- Tid Column -->
                    <ng-container matColumnDef="tid">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> TID </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <div>
                                {{ element.Tid }}
                                <br>
                                {{ element.origin }}
                            </div>
                        </mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="bank">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Bc/Ag/Cc </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <div>
                                {{ element.refund.bank }}
                                <br>
                                {{ element.refund.agency }}
                                <br>
                                {{ element.refund.account }}
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="discount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> % </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            {{ element.refund.discount }}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="total">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Valor </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <div>
                                {{ element.total | currency:'BRL':'':'1.2-2' }}
                                <br>
                                {{ element.refund.discount }} %
                            </div>
                        </mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="refund">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Reembolso </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{ element.refund.total | currency:'BRL':'':'1.2-2' }}
                        </mat-cell>
                    </ng-container>


                    <!-- edit Column -->
                    <ng-container matColumnDef="edit">
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <a mat-button (click)='openRefundDialog(element, true)'
                                style='background-color: whitesmoke;'>
                                <mat-icon class='icon-info' style='font-size:1.5em;'>
                                    info_outline
                                </mat-icon>
                            </a>
                        </mat-cell>
                    </ng-container>

                    <!-- Header -->
                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

                    <!-- Row -->
                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

                </mat-table>
                <!-- END TABLE -->

                <mat-paginator #paginatorRefund [pageSizeOptions]="[5, 10, 20, 40]"></mat-paginator>

            </mat-tab>

        </mat-tab-group>

    </mat-card>

</div>